function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#73BE1E",
  points: "226.015,42.498 225.956,42.587 225.956,42.498  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#38A22B",
  points: "236.957,27.882 231.441,35.264 226.015,42.498 225.956,42.498 225.956,42.413 111.416,42.413  111.416,13.176 225.956,13.176 231.441,20.559  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#73BE1E",
  points: "226.015,42.498 225.956,42.587 225.956,42.498  "
}), /*#__PURE__*/React.createElement("rect", {
  x: 193.589,
  y: 71.653,
  fill: "#73BE1E",
  width: 44.604,
  height: 0.082
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#73BE1E",
  points: "238.363,71.653 238.192,71.824 238.192,71.653  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#75BF1E",
  points: "249.222,57.118 243.734,64.501 238.363,71.653 111.416,71.653 111.416,42.413 193.589,42.413  193.589,42.498 225.956,42.498 225.956,42.587 226.015,42.498 238.192,42.498 238.192,42.413 243.734,49.796  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#73BE1E",
  points: "238.192,71.824 238.192,71.735 193.589,71.735 193.589,71.653 238.363,71.653  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#73BE1E",
  points: "250.629,100.891 250.456,101.091 250.456,100.891  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#73BE1E",
  points: "250.629,100.891 250.456,101.091 250.456,100.891  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#73BE1E",
  points: "262.864,130.128 262.721,130.328 262.721,130.128  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#73BE1E",
  points: "262.864,130.128 262.721,130.328 262.721,130.128  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#73BE1E",
  points: "275.126,159.395 274.983,159.565 274.983,159.395  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FFB000",
  points: "298.277,174.101 292.762,181.453 287.392,188.632 111.416,188.632 111.416,159.395  274.983,159.395 274.983,159.565 275.126,159.395 287.248,159.395 292.762,166.747  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#96CE17",
  points: "261.484,86.359 255.998,93.738 250.629,100.891 111.416,100.891 111.416,71.653 193.589,71.653  193.589,71.735 238.192,71.735 238.192,71.824 238.363,71.653 250.456,71.653 255.998,79.032  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#E3F215",
  points: "273.749,115.622 268.235,122.979 262.864,130.128 193.589,130.128 193.589,130.157  111.416,130.157 111.416,100.891 250.456,100.891 250.456,101.091 250.629,100.891 262.721,100.891 268.235,108.273  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FFD900",
  points: "286.013,144.859 280.497,152.216 275.126,159.395 111.416,159.395 111.416,130.157  193.589,130.157 193.589,130.128 262.721,130.128 262.721,130.328 262.864,130.128 274.983,130.128 280.497,137.51  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#73BE1E",
  points: "275.126,159.395 274.983,159.565 274.983,159.395  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#73BE1E",
  points: "287.383,188.622 287.235,188.803 287.235,188.622  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#73BE1E",
  points: "287.383,188.622 287.235,188.803 287.235,188.622  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FF7B00",
  points: "309.65,203.337 304.137,210.69 298.623,217.869 298.623,217.869 111.416,217.869 111.416,188.632  287.248,188.632 287.248,188.806 287.392,188.632 298.623,188.632 304.137,195.984  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#144576",
  points: "16.599,79.233 16.599,218.043 206.244,218.043 206.244,79.233 111.436,13.176 74.703,38.768  74.703,28.973 46.354,28.973 46.354,58.499  "
}), /*#__PURE__*/React.createElement("polygon", {
  opacity: 0.76,
  fill: "#D3C7C1",
  points: "223.665,79.233 223.665,218.043 206.229,218.043 206.229,79.233 120.156,19.267  111.423,13.176 111.423,13.176  "
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M215.429,19.503l6.064,16.672h-2.291l-2.146-5.897h-4.417l-2.137,5.897h-2.304l6.064-16.672H215.429z  M216.274,28.121l-1.428-3.908l-1.417,3.908H216.274z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M227.039,49.147c0.964,0,1.792,0.342,2.48,1.026c0.688,0.684,1.032,1.509,1.032,2.475 c0,0.993-0.5,1.607-1.501,1.844c0.724,0.105,1.545,0.618,2.466,1.542c0.918,0.924,1.378,2.202,1.378,3.836 c0,1.633-0.572,3.04-1.719,4.23c-1.076,1.117-2.156,1.683-3.239,1.695v0.023h-4.271V49.147H227.039z M225.821,51.304v2.637h1.405 c0.321-0.026,0.595-0.148,0.825-0.365c0.25-0.229,0.373-0.539,0.373-0.927c0-0.392-0.13-0.71-0.39-0.966 c-0.261-0.254-0.591-0.379-0.996-0.379H225.821z M225.821,56.159v7.49h2.115V63.62c0.444-0.029,0.996-0.385,1.655-1.074 c0.729-0.75,1.093-1.641,1.093-2.676c0-1.022-0.361-1.896-1.088-2.623s-1.598-1.088-2.62-1.088H225.821z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M245.634,90.911l1.612,1.45c-1.972,1.798-4.058,2.698-6.26,2.698c-2.356,0-4.365-0.832-6.021-2.491 c-1.661-1.66-2.491-3.669-2.491-6.021c0-2.348,0.83-4.355,2.491-6.022c1.657-1.669,3.665-2.501,6.021-2.501 c2.202,0,4.288,0.9,6.26,2.698l-1.612,1.47c-1.487-1.321-3.037-1.982-4.648-1.982c-1.745,0-3.237,0.622-4.477,1.854 c-1.239,1.238-1.858,2.731-1.858,4.483c0,1.755,0.619,3.254,1.858,4.489c1.239,1.236,2.731,1.854,4.477,1.854 C242.597,92.891,244.147,92.233,245.634,90.911z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M250.803,107.273c2.71,0.014,4.822,0.782,6.336,2.305c1.661,1.673,2.491,3.685,2.491,6.031 c0,2.354-0.83,4.365-2.491,6.031c-1.514,1.522-3.626,2.291-6.336,2.305h-1.581v-16.672H250.803z M251.378,109.473v12.283 c1.716,0,3.121-0.552,4.219-1.656c1.236-1.236,1.857-2.735,1.857-4.49c0-1.749-0.621-3.247-1.857-4.49 C254.499,110.019,253.094,109.473,251.378,109.473z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M269.149,136.422v2.16h-6.827v5.091h6.827v2.16h-6.827v5.095h6.827v2.169h-8.983v-16.675H269.149z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M281.771,165.679v2.156h-5.864v5.092h5.864v2.159h-5.864v7.265h-2.158v-16.672H281.771z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M295.254,209.396c-1.714,1.64-3.679,2.462-5.887,2.462c-2.354,0-4.362-0.832-6.022-2.492 c-1.661-1.659-2.491-3.668-2.491-6.021c0-2.35,0.83-4.354,2.491-6.021c1.66-1.67,3.668-2.501,6.022-2.501 c2.201,0,4.291,0.896,6.263,2.695l-1.615,1.473c-1.487-1.322-3.036-1.982-4.648-1.982c-1.742,0-3.234,0.621-4.473,1.854 c-1.241,1.236-1.861,2.731-1.861,4.483c0,1.755,0.62,3.254,1.861,4.49c1.239,1.235,2.731,1.854,4.473,1.854 c1.5,0,2.745-0.395,3.729-1.187v-5.035h2.158V209.396z"
}));

var SvgCostSavingHouse = function SvgCostSavingHouse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "320px",
    height: "230px",
    viewBox: "0 0 320 230",
    enableBackground: "new 0 0 320 230",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCostSavingHouse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cost-saving-house.2e32198f.svg";
export { ForwardRef as ReactComponent };